import React, { useState } from 'react';
import { compose, withState, defaultProps } from 'recompose';
import { hot } from 'react-hot-loader';
import { Modal, Header, Icon, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';

import { Offline, Online } from 'op/components/offline';
import { withLocale } from 'op/components/locale';
import { useHistory } from "react-router";
import { selectSystemSettings } from '../../../redux/reducers/system-settings/system-settings.selectors';

import ReportWarningModal from '../warning-modal/warning-modal.component';

const ReportSubmitModal = ({ locale, report, validation, openModal, setOpenModal, onRequestExit, onSubmit, onSave, online, systemSettings }) => {
    const [showKpiWarning, setShowKpiWarning] = useState(false);
    const [showTotalFailureWarning, setShowTotalFailureWarning] = useState(false);
    const [warningLocaleKey, setWarningLocaleKey] = useState('submit');
    const history = useHistory();

    const handleSubmitClick = () => {
        const hasFailedKpis = report.evaluations.some(evaluation => 
            evaluation.execution_level === null || evaluation.execution_level < 30
        );
        const isPassStatus = report.execution_level >= 30;

        if (report.isKPI && hasFailedKpis && isPassStatus && systemSettings.isAlertForFailKPI) {
            setWarningLocaleKey('kpiWarning');
            setShowKpiWarning(true);
        } else if (!isPassStatus && systemSettings.isAlertForTotalFailure) {
            setWarningLocaleKey('totalFailure');
            setShowTotalFailureWarning(true);
        } else {
            setOpenModal(true);
        }
    };


    return (
        <React.Fragment>
        <ReportWarningModal 
            open={showKpiWarning || showTotalFailureWarning}
            onCancel={() => {
                if (showKpiWarning) {
                    setShowKpiWarning(false);
                } else if (showTotalFailureWarning) {
                    setShowTotalFailureWarning(false);
                }
            }}
            onProceed={() => {
                if (showKpiWarning) {
                    setShowKpiWarning(false);
                } else if (showTotalFailureWarning) {
                    setShowTotalFailureWarning(false);
                }
                setOpenModal(true);
            }}
            warningLocaleKey={warningLocaleKey}
        />
        <Modal
            trigger={
                <Button
                    type='button'
                    primary
                    disabled={!validation.ok}
                    onClick={handleSubmitClick}
                >
                    {locale.saveOrSend}
                </Button>
            }
            open={openModal}
            onClose={() => setOpenModal(false)}
            basic
        >
            <Header icon='th list' content={locale.header} />
            <Modal.Content>
                {online ? (locale.content.map((line, i) => <p key={i}>{line}</p>)) : locale.content[0]}
            </Modal.Content>
            <Modal.Actions>
                <Button basic onClick={() => setOpenModal(false)} color='red' inverted floated='left'>
                    <Icon name='remove' /> {locale._system.cancel}
                </Button>
                <Online>
                    <Button 
                        onClick={() => {
                            onSave();
                            setOpenModal(false);
                        }} 
                        color='blue' 
                        inverted
                    >
                        <Icon name='checkmark' /> {locale._system.save}
                    </Button>
                    <Button 
                        onClick={() => {
                            onSubmit();
                            setOpenModal(false);
                        }} 
                        color='green' 
                        inverted
                    >
                        <Icon name='mail' /> {locale.send}
                    </Button>
                </Online>
                <Offline>
                    <Button onClick={() => {
                        onRequestExit();
                        setOpenModal(false);
                        history.push({ pathname: '/pending' });
                    }} color='blue' inverted>
                        <Icon name='checkmark' /> {locale._system.save}
                    </Button>
                </Offline>
            </Modal.Actions>
        </Modal>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    systemSettings: selectSystemSettings(state)
});

export default compose(
    connect(mapStateToProps),
    withLocale('report.submit'),
    withState('openModal', 'setOpenModal', false),
    defaultProps({
        onSave: () => {
        },
        onSubmit: () => {
        },
    }),
    hot(module),
)(ReportSubmitModal);
